import React from 'react';

import { message } from 'antd';
import type { UploadProps } from 'antd/es/upload';

import { useTranslation } from 'react-i18next';

import { NSKeys } from '@app/i18n';
import { OrderFileDTO } from '@app/models/orders';
import { Upload } from '@components/AntFields';

interface IProps {
  id?: string;
  disabled?: boolean;
  value?: OrderFileDTO[];
  onChange?: (value: { uid: string }[]) => void;
}

const ACCEPT =
  'application/pdf,' +
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,' +
  'application/vnd.ms-excel,' +
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document,' +
  'application/msword,' +
  '.pdf,.xlsx,.xls,.docx,.doc';

export const MultiFile: React.FC<IProps> = (props) => {
  const commonT = useTranslation(NSKeys.common);
  const ordersT = useTranslation(NSKeys.orders);
  const [fileList, setFileList] = React.useState<any>([]);

  React.useEffect(() => {
    if (props.value?.length && fileList.length === 0) {
      setFileList(
        props.value.map((el) => ({
          uid: el.uid,
          name: el.name,
          status: 'done',
          url: el.url,
        }))
      );
    }
  }, [props.value]);

  const handleChange: UploadProps['onChange'] = (info) => {
    const status = info.file.status;

    if (status === 'removed') {
      const data = info?.fileList
        .filter((el) => {
          const initUid = el?.response?.uid || el?.uid;
          const delUid = info.file?.response?.uid || info.file?.uid;
          return initUid !== delUid;
        })
        .map((el) => ({ uid: el?.response?.uid || el.uid }));
      props.onChange?.(data);
    }
    if (status === 'done') {
      const data = info?.fileList.map((el) => ({ uid: el?.response?.uid || el.uid }));
      props.onChange?.(data);
    }
    setFileList(info?.fileList);
    if (status === 'error') {
      setFileList((prev: any[]) => prev.filter((el) => el.status !== 'error'));
      message.error(commonT.t('error400'));
    }
  };

  return (
    <Upload
      fileList={fileList}
      apiPath={'orders/order-files/upload'}
      listType="text"
      name="media"
      accept={ACCEPT}
      disabled={!!props?.disabled}
      multiple={true}
      maxCount={10}
      description={ordersT.t('uploadFileDescription' as any)}
      onChange={handleChange}
    />
  );
};
